export default __webpack_public_path__ + "static/not_image.png";